import { observer } from "mobx-react-lite"
import { Text } from "./.."
import { StyledButton, StyledButtonProps } from "./StyledButton"

interface IBorderButtonProps extends Omit<StyledButtonProps, "style"> {
	text: string
	active?: boolean
}

export const BorderButton = observer(({ text, active, disabled, ...rest }: IBorderButtonProps) => {
	return (
		<StyledButton
			style={`${disabled ? "bg-[#202020]" : ""}
			${active ? "bg-white text-black" : "bg-black text-white"}
			grow flex h-[50px] flex-row items-center justify-center rounded border border-white max-w-[300px]`}
			{...rest}
		>
			<Text>{text}</Text>
		</StyledButton>
	)
})
